<template>
    <BasePanel 
        :headline="getPanelHeadline"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>

            <v-row>
                    <v-col>
                        <v-card elevation="0">
                        <v-card-text class="d-flex align-center">
                            <span class="read-only">
                                Werk-ID: {{ getSocietyMetadataWorkId }} | Status: {{ getSocietyMetadataWorkStatus }}
                            </span>
                            <BaseIcon
                                v-if="parseInt(societyCode) === 35 && society.metadata && society.metadata.workId"
                                class="ml-2"
                                icon="link"
                                tooltipText="lang_PUBLISHING_WORKS_CAPTION_GEMA_REPERTOIRE_TOOLTIP"
                                @click.stop="onClickGemaRepertoireSearch"
                            />
                                </v-card-text>
                        </v-card>
                    </v-col>
            </v-row>

            <GemaRepertoireDialog
                :show="showGemaRepertoireDialog"
                :work-id="gemaRepertoireWorkId"
                :alvqa="alvqa + '-gema-repertoire-dialog'"
                @close="closeGemaRepertoireDialog"
            />

            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items="society.parties"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :header-props="{ sortIcon: '' }"
                :items-per-page="itemsPerPage"
            >
                <!-- alvqas for headers -->
                    <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                <template v-slot:[`item.name`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip 
                            :simpleText="item.name + ' (' +  $alvPlugin.getRolePosition(item.role, item.position) + ')'"
                            :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-name'"
                        />
                    </div>
                    <div class="ellipsis subtitleGray--text">
                        <router-link 
                            v-if="typeof item.azEntity.alvId == 'string'"
                            :to="$alvPlugin.createUrlForAlvId(item.azEntity.alvId)"
                            target="_blank"
                        >
                            <BaseTooltip 
                                :simpleText="$alvPlugin.getIpiAlvIdForInterestedParty(item)"
                                :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-ipi'"
                            />
                        </router-link>
                    </div>
                </template>
                 <template v-slot:[`item.role`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-role'">
                        {{ item.role }}
                    </div>
                </template>
                <template v-slot:[`item.ctrl`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-ctrl'">
                        {{ item.ctrl === true ? $t('lang_GENERAL_YES') : $t('lang_GENERAL_NO') }} 
                        </div>
                </template>
                <template v-slot:[`item.uvz`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-uvz'">
                        {{ getUvzCommaSeparated(item.uvz) }}
                    </div>
                </template>
                    <template v-slot:[`item.societyPrMr`]="{ item }">
                        <div class="ellipsis">
                            <BaseTooltip 
                                :simpleText="showSocietyNames(item.societyPr, item.societyMr)"
                                :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-society-pr-mr'"
                            />
                        </div>
                    </template>

                <!-- Number formatting for all percentages -->
                <template v-slot:[`item.percentPr`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-percent-ar'">
                        {{ $alvPlugin.getNumberLocalization(item.percentPr, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.percentMr`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-percent-mr'">
                        {{ $alvPlugin.getNumberLocalization(item.percentMr, 'number') }}
                    </div>
                </template>

                <!-- PMR aka ZBS -->
                <!-- <template v-slot:[`item.pmr`]="{ item }">
                    <div v-if="item.pmr != 0" :alvqa="alvqa +'-list-row-' + item.id + '-text-pmr'">
                        {{ item.pmr }}
                    </div>
                    <div v-else>
                    </div>
                </template> -->
                <!-- ********* SUM ROW ********* -->
                <template slot="body.append">
                    <tr> 
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td align="left" class="data-table-sum-row">{{ $t('lang_GENERIC_CAPTION_SUM') }}</td>
                        <!-- First Sum Column -->
                        <td align="right" class="data-table-sum-row" v-if="society.parties.length === 0 || sumField('percentPr') === null"><div>{{ $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM") }}</div></td>
                        <td align="right" class="data-table-sum-row" v-else-if="sumField('percentPr') !== '100.00'"><div id="not100">{{ $n(sumField('percentPr'),"number") }}</div></td>
                        <td align="right" class="data-table-sum-row" v-else><div>{{ $n(sumField('percentPr'),"number") }}</div></td>
                        <!-- Second Sum Column -->
                        <td align="right" class="data-table-sum-row" v-if="society.parties.length === 0 || sumField('percentMr') === null"><div>{{ $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM") }}</div></td>
                        <td align="right" class="data-table-sum-row" v-else-if="sumField('percentMr') !== '100.00'"><div id="not100">{{ $n(sumField('percentMr'),"number") }}</div></td>
                        <td align="right" class="data-table-sum-row" v-else><div>{{ $n(sumField('percentMr'),"number") }}</div></td>
                    </tr>
                </template>
            <!-- this.society.parties.length === 0 -->
            </v-data-table>

        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'
import GemaRepertoireDialog from '@/components/_dialogs/GemaRepertoireDialog'
// DropdownPublishingWorksStatus (translated work status from GEMA / historical ALV = non-CWR)
import {    
        DropdownPublishingWorksStatus, 
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "WorkSocietySharesPanel",
    components: {
        BasePanel,
        BaseTooltip,
        BaseIcon,
        GemaRepertoireDialog,
    },
    props:{
        societyCode: String,
        society: Object,
        workAlvId: {
            type: String
        },
    },
    data() {
        return {
            alvqa : "publishing-works-list-row-" + this.workAlvId + "-read-only-panel-" + this.societyCode + "-society-shares",
            showGemaRepertoireDialog: false,
            gemaRepertoireWorkId: '',
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INTERESTED_PARTY"),
                    value: "name",
                    align: "left", 
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-interested-party'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_ROLE"), 
                    value: "role",
                    align: "left", 
                    width: "80px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-role'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_CTRL"), 
                    align: "left", 
                    value: "ctrl", 
                    width: "80px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-ctrl"
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_UVZ"), 
                    align: "left", 
                    value: "uvz", 
                    width: "90px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-uvz'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_SOCIETY_PR_MR'), 
                    value: "societyPrMr",
                    align: "left",
                    width: "180px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-society-pr-mr'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_COLL_PERCENT_PR'), 
                    value: "percentPr",
                    align: "right",
                    width: "120px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-coll-percent-pr'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_COLL_PERCENT_MR'), 
                    value: "percentMr",
                    align: "right",
                    width: "120px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-coll-percent-mr'
                },
                // {
                //     text: this.$t('lang_GENERAL_PMR'),
                //     value: "pmr",
                //     align: "right",
                //     width: "90px",
                //     class: 'text-no-wrap',
                //     sortable: false,
                //     alvqa: this.alvqa + '-header-pmr-payable-mr'
                // },
            ]
        },
        getPanelHeadline() {
            return this.$alvPlugin.getSocietyName(parseInt(this.societyCode)) + '-' + this.$t('lang_GENERAL_CAPTION_SHARES')
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        
        getSocietyMetadataWorkId() {
            if (this.society.metadata.workId != null)
                return this.society.metadata.workId
            else
                return this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
        },
        
        getSocietyMetadataWorkStatus() {
            if (this.society.metadata.status != null) {
                if (this.society.metadata.sourceStatus != null)
                    return this.society.metadata.sourceStatus // in case of CWR ACK, e.g. "RA"
                else {
                    let gemaStatus = this.society.metadata.status
                    let match = DropdownPublishingWorksStatus.find(status => {
                        return status.value === gemaStatus
                    })
                    if(match !== undefined) return this.$t(match.text)
                    else return gemaStatus
                }
            }
            else
                return this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
        },
    },
    methods: {
        onClickGemaRepertoireSearch() {
            if (!this.society || !this.society.metadata || !this.society.metadata.workId) {
                return
            }
            this.gemaRepertoireWorkId = String(this.society.metadata.workId)
            this.showGemaRepertoireDialog = true
        },
        closeGemaRepertoireDialog() {
            this.showGemaRepertoireDialog = false
            this.gemaRepertoireWorkId = ''
        },
        sumField(column) {
            let listOfParties = this.society.parties
            let sum = null
            for (const party of listOfParties) {
                if (party[column] !== null) {
                    sum += party[column] 
                 } 
            }
            return sum !== null ? sum.toFixed(2) : sum
        },
        getUvzCommaSeparated(uvzArr) {
            let uvz = []
            uvzArr.forEach(element => {
                if (element) {
                    uvz.push(element.role+element.position)
                }
            });

            return uvz.join(', ')
        },

        showSocietyNames(societyPr, societyMr) {
            let societyNameAr = this.$alvPlugin.getSocietyName(societyPr)
            let societyNameMr = this.$alvPlugin.getSocietyName(societyMr)

            if(societyNameAr == '' && societyNameMr === '') return ''
            else return societyNameAr + ' | ' + societyNameMr
        },
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
    #not100{
        color:  var(--v-error-base)
    }
</style>
